"use client";

import { useEffect, useMemo, useState } from "react";
import { CONTACT, SOCIAL } from "@/lib/site-data";

type Setting = {
  phone?: string;
  whatsapp?: string;
  email?: string;
  address?: string;
  mapEmbed?: string;
  openingHours?: string;
  facebook?: string;
  instagram?: string;
  youtube?: string;
  linkedin?: string;
  social?: Record<string, string>;
};

export function usePublicSettings() {
  const [setting, setSetting] = useState<Setting>({});
  useEffect(() => {
    const controller = new AbortController();
    fetch("/api/public/settings", { signal: controller.signal })
      .then((response) => response.ok ? response.json() : Promise.reject(new Error("Settings request failed")))
      .then((data: { contact?: Setting }) => setSetting(data.contact || {}))
      .catch(() => undefined);
    return () => controller.abort();
  }, []);
  return useMemo(() => {
    const phone = setting.phone || CONTACT.phone;
    const digits = phone.replace(/\D/g, "");
    const socialValues: Record<string, string | undefined> = setting.social || {
      facebook: setting.facebook,
      instagram: setting.instagram,
      youtube: setting.youtube,
      linkedin: setting.linkedin,
    };
    const social = SOCIAL.map((item) => ({
      ...item,
      href: socialValues[item.label.toLowerCase()] || item.href,
    }));
    const whatsappDigits = (setting.whatsapp || digits).replace(/\D/g, "");
    return {
      contact: {
        ...CONTACT,
        phone,
        phoneHref: `tel:+${digits}`,
        whatsappHref: `https://api.whatsapp.com/send/?phone=${whatsappDigits}&text=Hi, I have a query!`,
        email: setting.email || CONTACT.email,
        address: setting.address || CONTACT.address,
        mapEmbed: setting.mapEmbed,
        openingHours: setting.openingHours,
      },
      social,
    };
  }, [setting]);
}
